import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import api, { handleApiError } from '../../helpers/api';
import {
  fetchJobsSuccess,
  fetchJobsFailure,
  addJobSuccess,
  addJobFailure,
  updateJobSuccess,
  updateJobFailure,
  deleteJobSuccess,
  deleteJobFailure,
} from './action';
import {
  FETCH_JOBS_REQUEST,
  ADD_JOB_REQUEST,
  UPDATE_JOB_REQUEST,
  DELETE_JOB_REQUEST,
} from './actionType';

function* fetchJobs({ payload: { dispatch, navigate } }) {
  try {
    const response = yield call(api.get, '/carriere', {
      withCredentials: true,
    });
    const jobs = response.data.map((job) => ({
      id: job._id,
      jobTitle: job.titre,
      jobPosition: job.position,
      jobType: job.type,
      jobCategory: job.category,
      startSalary: job.startSalary,
      lastSalary: job.lastSalary,
      country: job.country,
      state: job.state,
      company: job.company,
      tags: job.tags,
      candidateCount: job.candidateCount,
      lastDateApply: job.lastDateApply,
      closeDate: job.closeDate,
      description: job.description,
      datePublication: job.datePublication,
      createdBy: job.createdBy,
    }));

    yield put(fetchJobsSuccess(jobs));
  } catch (error) {
    yield put(fetchJobsFailure(error.message));
    yield call(toast.error, `Failed to fetch jobs: ${error.message}`);
    yield call(handleApiError, error, dispatch, navigate);
  }
}

function* addJob(   payload  ) {
  try {
    console.log("Adding job with data:", payload.payload);
    const response = yield call(api.post, '/carriere', payload.payload, {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    yield put(addJobSuccess({
      id: response.data._id,
      jobTitle: response.data.titre,
      jobPosition: response.data.position,
      jobType: response.data.type,
      jobCategory: response.data.category,
      startSalary: response.data.startSalary,
      lastSalary: response.data.lastSalary,
      country: response.data.country,
      state: response.data.state,
      company: response.data.company,
      tags: response.data.tags,
      candidateCount: response.data.candidateCount,
      lastDateApply: response.data.lastDateApply,
      closeDate: response.data.closeDate,
      description: response.data.description,
      datePublication: response.data.datePublication,
      createdBy: response.data.createdBy,
    }));
  } catch (error) {
    yield put(addJobFailure(error.message));
    // yield call(handleApiError, error, dispatch, navigate);
    yield call(toast.error, `Failed to add job: ${error.message}`);
  }
}

function* updateJob({ payload: { id, data, dispatch, navigate } }) {
  try {
    const response = yield call(api.patch, `/carriere/${id}`, data, {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
    yield put(updateJobSuccess({
      id: response.data._id,
      jobTitle: response.data.titre,
      jobPosition: response.data.position,
      jobType: response.data.type,
      jobCategory: response.data.category,
      startSalary: response.data.startSalary,
      lastSalary: response.data.lastSalary,
      country: response.data.country,
      state: response.data.state,
      company: response.data.company,
      tags: response.data.tags,
      candidateCount: response.data.candidateCount,
      lastDateApply: response.data.lastDateApply,
      closeDate: response.data.closeDate,
      description: response.data.description,
      datePublication: response.data.datePublication,
      createdBy: response.data.createdBy,
    }));
  } catch (error) {
    yield put(updateJobFailure(error.message));
    yield call(handleApiError, error, dispatch, navigate);
    yield call(toast.error, `Failed to update job: ${error.message}`);
  }
}

function* deleteJob({ payload: { id, dispatch, navigate } }) {
  try {
    yield call(api.delete, `/carriere/${id}`, {
      withCredentials: true,
    });
    yield put(deleteJobSuccess({ id }));
  } catch (error) {
    yield put(deleteJobFailure(error.message));
    yield call(handleApiError, error, dispatch, navigate);
    yield call(toast.error, `Failed to delete job: ${error.message}`);
  }
}

export default function* jobSaga() {
  yield takeEvery(FETCH_JOBS_REQUEST, fetchJobs);
  yield takeEvery(ADD_JOB_REQUEST, addJob);
  yield takeEvery(UPDATE_JOB_REQUEST, updateJob);
  yield takeEvery(DELETE_JOB_REQUEST, deleteJob);
}